import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type GeneralState = {
  subdomain: string;
};

const initialState: GeneralState = {
  subdomain: ''
};

export const generalReducerName = 'general';

const generalSlice = createSlice({
  name: generalReducerName,
  initialState,
  reducers: {
    setSubdomain: (state, action: PayloadAction<string>) => {
      state.subdomain = action.payload;
    }
  }
});

export const generalReducer = generalSlice.reducer;
export const { setSubdomain } = generalSlice.actions;
